import DeviceClass from "./DeviceClass";

export default new DeviceClass({
  forceDash: typeof window === "undefined" ? false : !!window.FORCE_DASH,
  forceHLS: typeof window === "undefined" ? false : !!window.FORCE_HLS,
  navigator: window.navigator,
  screenHeight: window.screen.height,
});
